<template>
  <section class="teacher-extra-learning">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item,index) in resourceList"
        :key="index"
        :label="item.label + '('+item.list.length+')'"
        :name="item.name"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="tableData"
      stripe
      width="100%" class="tac" :header-cell-style="{'text-align':'center'}"
    >
      <el-table-column
        prop="name"
        label="资源"
      >
        <template slot-scope="scope">
          <a href="javascript:;" @click.stop="previewResource(scope.row)">{{scope.row.name}}.{{scope.row.file_type}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="learning_num" label="学习次数">

      </el-table-column>
      <el-table-column
        label="操作"
        width="180"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="checkStudy(scope.row)">查看学习情况</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="学生学习情况"
      :visible.sync="dialogDocument"
      width="70%"
     >
      <el-row>
        <el-col :span="4">未读学生：</el-col>
        <el-col :span="20">
          <ul class="student-list">
            <li class="list fl tac" v-for="(item,index) in studentList.unRead" :key="index">
              <div class="student-avatar">
                <img v-lazy="cdn(item.picture) || defaultImage.studentAvatar" data-format="90">
              </div>
              <p class="student-name">{{item.real_name}}</p>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="4">已读学生：</el-col>
        <el-col :span="20">
          <ul class="student-list">
            <li class="list fl tac" v-for="(item,index) in studentList.read" :key="index">
              <div class="student-avatar">
                <img v-lazy="cdn(item.picture) || defaultImage.studentAvatar" data-format="90">
              </div>
              <p class="student-name">{{item.real_name}}</p>
            </li>
          </ul>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      title="学生学习情况"
      :visible.sync="dialogVideo"
      width="50%"
      >

      <ul class="student-list">
        <li v-for="(item,index) in progressList" :key="index">
          <el-row class="p20">
            <el-col :span="6">
              <div class="student-avatar tac">
                <img v-lazy="cdn(item.picture) || defaultImage.studentAvatar" data-format="90">
                <p class="student-name">{{item.real_name}}</p>
              </div>
            </el-col>
            <el-col :span="12" class="pt20">
              <el-progress
                :text-inside="true"
                :stroke-width="18"
                :percentage="item.resource_play_progress"></el-progress>
            </el-col>
          </el-row>
        </li>
      </ul>
    </el-dialog>
    <el-dialog
      :title="'资源预览：' + (bookResourceDetail.detail.name || '') + '.' + (bookResourceDetail.detail.file_type || '')"
      top="6%"
      :visible.sync="bookResourceDetail.isPreview"
      width="80%"
      height="80%"
      class="previewDialog">
      <resource-preview :file="bookResourceDetail.detail" v-if="bookResourceDetail.isPreview"></resource-preview>
    </el-dialog>
  </section>
</template>

<script>
  import{
    mapActions,
    mapGetters
  } from 'vuex';
  import ResourcePreview from 'src/components/components/ResourcePreview.vue';
  import {
    find
  } from 'lodash';
  import {
    defaultImage
  } from 'src/config/config';
  export default {
    name: "index",

    data(){
      return {
        defaultImage,
        dialogDocument: false,
        dialogVideo: false
      }
    },
    components: {
      ResourcePreview
    },

    computed: {
      ...mapGetters({
        resourceList : 'getExtraLearningList',
        studentList: 'getStaticStudentList',
        progressList: 'getStaticVideoProgressList',
        bookResourceDetail: 'getTeacherBookResourceDetail'
      }),

      activeName: {
        get: function(){
          let name = this.$route.query && this.$route.query.name || '';
          if(name !=='' && this.resourceList.length){
            return name
          } else if(this.resourceList.length) {
            return this.resourceList[0].name
          } else {
            return ''
          }
        },

        set: function () {

        }
      },

      tableData(){
        if(this.resourceList.length && this.activeName){
          return find(this.resourceList, {name: this.activeName}).list;
        }
        return  ''
      }
    },

    created(){
      let postData = {
        grade_id: this.$route.params.grade_id
      };

      this.getExtraResourceList(postData);
    },


    methods: {
      ...mapActions({
        getExtraResourceList: 'actionGetExtraResourceList',
        getTeacherDoucmentStatic: 'actionGetTeacherDocumentStatic',
        getTeacherVideoStatic: 'actionGetTeacherVideoStatic',
        // 获取资源详情
        'bookResourcePreview': 'actionTeacherBookResourcePreview'
      }),


      handleClick(tab) {
        let name = tab.name;
        this.$router.replace({
          name: 'teacher_grade_manage_extralearning',
          query: {
            name: name
          }
        })
      },

      checkStudy(item){
        let type = item.group_type;
        let postData = {
          grade_id: this.$route.params.grade_id,
          resource_id: item.id
        };
        if(type !== '视频'){
          this.getTeacherDoucmentStatic(postData);
          this.dialogDocument = true;
        } else {
          this.getTeacherVideoStatic(postData);
          this.dialogVideo = true;
        }

      },

      // 预览资源
      previewResource(item){
        this.bookResourcePreview({resource_id: item.id});
      }
    }
  }
</script>

<style lang="less" scoped>

  .teacher-extra-learning{

    .list{
      width: 70px;
      padding: 5px;
    }

    .student-avatar{
      width: 60px;
      height: 60px;

      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #f6f3f5;
      }
    }

    .student-name{
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
    }

  }
</style>
<style scoped>
  >>> .el-dialog__body{
    min-height: 400px;
    max-height: 500px;
    overflow-y: auto;
  }
</style>
